import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"
gsap.registerPlugin(ScrollTrigger);

export default function index(){
  /*
  const firstview = document.getElementById('firstview')
  gsap.utils.toArray(firstview).forEach((el, index) => {
    gsap.fromTo(el,
      {},
      {
        y: '-15%',
        opacity: .5,
        scrollTrigger: {
          trigger: '.spacer',
          start: "center top",
          end: "bottom top",
          scrub: 1,
          once: false,
          //markers: true
        }
      }
    )  
  })
    */
}